// Canonical acknowledgement wording (tracking_tasks.md TRK-1.6 / TRK-3.1).
//
// The SERVER (pb_hooks/audit.pb.js) is authoritative — the client cannot
// choose the stored wording. This mirror exists so the acknowledge modal
// can preview the exact sentence that will be stored. If the wording ever
// changes, update BOTH this file and the hook (TBC-7: solicitor review
// pending before relying on acknowledgements in disputes).

export function acknowledgementText(fileName, version) {
  return `I confirm I have opened and read "${fileName}" (version ${version}) in the during.uk client portal.`;
}
